/**
 * RAA Form Builder — v1.2
 * v1.1: Conditional fields, section_divider, boolean, checkbox-with-options
 * v1.2: Half-width grid layout, multi-photo image uploader with canvas resize,
 *       year-start warning, required_group validation, Drive photo upload
 */
(function () {
  'use strict';

  // Inline SVG icons (subset of Lucide) — avoids CDN dependency
  var ICONS = {
    'list':    '<line x1="8" x2="21" y1="6" y2="6"/><line x1="8" x2="21" y1="12" y2="12"/><line x1="8" x2="21" y1="18" y2="18"/><line x1="3" x2="3.01" y1="6" y2="6"/><line x1="3" x2="3.01" y1="12" y2="12"/><line x1="3" x2="3.01" y1="18" y2="18"/>',
    'palette': '<circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/><circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/><circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/><circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>',
    'info':    '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>',
    'tag':     '<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/>',
    'trophy':  '<path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/>',
    'gift':    '<polyline points="20 12 20 22 4 22 4 12"/><rect width="20" height="5" x="2" y="7"/><line x1="12" x2="12" y1="22" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>',
    'star':    '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
    'alert-circle': '<circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/>',
    'check-circle': '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>',
    'users':   '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
    'link':    '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>',
  };

  function renderIcon(name, style) {
    var inner = ICONS[name];
    if (!inner) return '';
    var s = style || 'width:15px;height:15px;vertical-align:middle;margin-right:6px;flex-shrink:0';
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="' + s + '" aria-hidden="true">' + inner + '</svg>';
  }

  // Per-uploader file storage (keyed by DOM element)
  var uploaderFiles = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  // ─── INIT ────────────────────────────────────────────────────────────────

  function initForms() {
    document.querySelectorAll('[data-form-handle]').forEach(function (container) {
      var handle = container.dataset.formHandle;
      var config = window.RAAFormConfig && window.RAAFormConfig[handle];
      if (config) renderForm(container, config);
    });
  }

  // ─── RENDER FORM ─────────────────────────────────────────────────────────

  function renderForm(container, config) {
    var target = document.getElementById('raa-form-render-' + config.handle);
    if (!target) return;

    // Apply per-form style overrides from admin styling options
    var styleConfig = {};
    try { styleConfig = JSON.parse(config.styleJson || '{}'); } catch(e) {}
    if (styleConfig.btn_bg)    container.style.setProperty('--raa-btn-bg',    styleConfig.btn_bg);
    if (styleConfig.btn_color) container.style.setProperty('--raa-btn-color', styleConfig.btn_color);
    if (styleConfig.accent)    container.style.setProperty('--raa-accent',    styleConfig.accent);
    if (styleConfig.radius)    container.style.setProperty('--raa-radius',    styleConfig.radius);

    if (config.membersOnly && !config.customerLoggedIn) {
      target.innerHTML =
        '<p class="raa-form-members-only">This form is for RAA members only. ' +
        '<a href="/account/login">Log in</a> to access it.</p>';
      return;
    }

    var html = '';
    if (config.showTitle !== false && config.title) {
      html += '<h2 class="raa-form-heading">' + esc(config.title) + '</h2>';
    }
    if (config.showDescription !== false && config.description) {
      html += '<div class="raa-form-description">' + esc(config.description) + '</div>';
    }

    html += '<form class="raa-form" id="raa-form-' + esc(config.handle) + '" novalidate>';
    html += '<div class="raa-form-fields-grid">';

    (config.fields || []).forEach(function (field, i) {
      html += renderField(field, i, config);
    });

    html += '</div>'; // close raa-form-fields-grid

    // Parse ui text for success action buttons
    var uiTextForSuccess = {};
    try { uiTextForSuccess = JSON.parse(config.uiTextJson || '{}'); } catch(e) {}
    var successBtns = '';
    var sb1Label = uiTextForSuccess.success_btn_1_label;
    var sb1Url   = uiTextForSuccess.success_btn_1_url;
    var sb2Label = uiTextForSuccess.success_btn_2_label;
    var sb2Url   = uiTextForSuccess.success_btn_2_url;
    var sb3Label = uiTextForSuccess.success_btn_3_label;
    var sb3Url   = uiTextForSuccess.success_btn_3_url;
    // Only render a button if it has been explicitly configured with a non-empty label
    if (sb1Label) {
      successBtns += '<a href="' + esc(sb1Url || window.location.pathname) + '" class="raa-form-success-btn button">' + esc(sb1Label) + '</a>';
    }
    if (sb2Label) {
      successBtns += '<a href="' + esc(sb2Url || '/account') + '" class="raa-form-success-btn button">' + esc(sb2Label) + '</a>';
    }
    if (sb3Label) {
      successBtns += '<a href="' + esc(sb3Url || '/pages/manage-my-entries') + '" class="raa-form-success-btn button">' + esc(sb3Label) + '</a>';
    }

    html +=
      '<div class="raa-form-submit-row">' +
        '<button type="submit" class="raa-form-submit-btn button">' + esc(config.submitLabel || 'Submit') + '</button>' +
      '</div>' +
    '</form>' +
    '<div class="raa-form-success" style="display:none;" aria-live="polite">' +
      '<div class="raa-form-success-inner">' +
        '<span class="raa-form-success-icon">' + RAA_icon('circle-check', 40) + '</span>' +
        '<p>' + esc(config.confirmationMessage) + '</p>' +
        (successBtns ? '<div class="raa-form-success-btns">' + successBtns + '</div>' : '') +
      '</div>' +
    '</div>' +
    '<div class="raa-form-error-banner" style="display:none;" role="alert">' +
      'Something went wrong. Please check your answers and try again.' +
    '</div>';

    target.innerHTML = html;

    var formEl = target.querySelector('.raa-form');
    if (formEl) {
      initConditionals(formEl);
      initImageUploaders(formEl);
      initYearWarnings(formEl);
      initEntryCodeAutoPopulate(formEl, config);
      initUrlValidation(formEl);
      formEl.addEventListener('submit', function (e) {
        handleSubmit(e, formEl, config, target);
      });
    }

    initRatingInputs(target);
  }

  // ─── RENDER FIELD ────────────────────────────────────────────────────────

  function renderField(field, index, formConfig) {
    var type = field.type || 'text';
    var id = field.key || field.id || ('field_' + index);
    var inputId = 'raa-field-' + id;
    var label = field.label || '';
    var req = field.required ? true : false;
    var reqAttr = req ? ' required data-orig-required="true"' : '';
    var placeholder = field.placeholder ? ' placeholder="' + esc(field.placeholder) + '"' : '';
    // field_note supports HTML (admin-authored, not user input)
    var fieldNote = field.field_note
      ? '<span class="raa-form-field-note">' + field.field_note + '</span>'
      : '';
    var errorEl = '<div class="raa-form-field-error" id="' + inputId + '-error" role="alert" aria-live="polite"></div>';

    // Half-width (span 1 column) — full by default (span 2)
    var halfClass = field.half_width ? ' raa-form-field--half' : '';

    // Conditional show/hide
    var showIf = field.showIf;
    var conditionalAttr = showIf
      ? ' data-show-if=\'' + JSON.stringify(showIf).replace(/'/g, '&#39;') + '\' style="display:none"'
      : '';
    var conditionalClass = showIf ? ' raa-form-field--conditional' : '';

    // Required group (at least one in group must be filled)
    var groupAttr = field.required_group
      ? ' data-required-group="' + esc(field.required_group) + '"' +
        (field.required_group_min ? ' data-required-group-min="' + parseInt(field.required_group_min) + '"' : '')
      : '';

    // ── Layout / display elements (always full width) ─────────────────────
    if (type === 'section_divider' || type === 'title') {
      var sdAttrs = showIf ? ' data-show-if=\'' + JSON.stringify(showIf).replace(/'/g, '&#39;') + '\' style="display:none"' : '';
      return '<h3 class="raa-form-section-title"' + sdAttrs + '>' + esc(label) + '</h3>';
    }
    if (type === 'body') {
      var bodyAttrs = showIf ? ' data-show-if=\'' + JSON.stringify(showIf).replace(/'/g, '&#39;') + '\' style="display:none"' : '';
      return '<div class="raa-form-body-text"' + bodyAttrs + '>' + esc(label) + '</div>';
    }
    if (type === 'note') {
      return '<p class="raa-form-note-text">' + esc(label) + '</p>';
    }
    if (type === 'spacer') {
      return '<div class="raa-form-spacer" aria-hidden="true"></div>';
    }
    if (type === 'line_break') {
      return '<hr class="raa-form-divider" aria-hidden="true">';
    }
    if (type === 'hidden') {
      return '<input type="hidden" name="' + esc(id) + '" value="' + esc(field.value || '') + '">';
    }
    if (type === 'info') {
      var infoAttrs = showIf ? ' data-show-if=\'' + JSON.stringify(showIf).replace(/'/g, '&#39;') + '\' style="display:none"' : '';
      var infoContent = field.content || '';
      if (field.collapsible) {
        var iconHtml = field.icon ? renderIcon(field.icon) : '';
        return '<details class="raa-form-info-panel"' + infoAttrs + '><summary class="raa-form-info-summary">' + iconHtml + esc(field.summary || label) + '</summary><div class="raa-form-info-body">' + infoContent + '</div></details>';
      }
      return '<div class="raa-form-info-panel"' + infoAttrs + '>' + (label ? '<div class="raa-form-info-summary">' + esc(label) + '</div>' : '') + '<div class="raa-form-info-body">' + infoContent + '</div></div>';
    }

    // ── Boolean / single agreement checkbox ──────────────────────────────
    var isSingleCheckbox = type === 'boolean' || (type === 'checkbox' && (!field.options || !field.options.length));
    if (isSingleCheckbox) {
      return (
        '<div class="raa-form-field raa-form-field--full raa-form-field--checkbox' + conditionalClass + '" data-field-id="' + inputId + '" data-key="' + esc(id) + '"' + conditionalAttr + '>' +
          '<label class="raa-form-checkbox-label">' +
            '<input type="checkbox" id="' + inputId + '" name="' + esc(id) + '" value="true"' + reqAttr + '>' +
            ' ' + esc(label) + (req ? ' <span class="raa-form-required" aria-hidden="true">*</span>' : '') +
          '</label>' +
          errorEl +
        '</div>'
      );
    }

    // ── Image uploader (custom multi-photo UI) ────────────────────────────
    if (type === 'image') {
      var maxFiles = field.max_files || 1;
      var addBtnLabel = maxFiles === 1 ? 'Add Photo' : 'Add Photos';
      var counterText = '0 / ' + maxFiles + ' photo' + (maxFiles !== 1 ? 's' : '') + ' added';
      var reqMark0 = req ? ' <span class="raa-form-required" aria-hidden="true">*</span>' : '';
      var requiredIfAttr = field.requiredIf
        ? ' data-required-if=\'' + JSON.stringify(field.requiredIf).replace(/'/g, '&#39;') + '\''
        : '';
      return (
        '<div class="raa-form-field raa-form-field--full' + conditionalClass + '" data-field-id="' + inputId + '" data-key="' + esc(id) + '"' + conditionalAttr + '>' +
          '<label class="raa-form-label">' + esc(label) + reqMark0 + '</label>' +
          fieldNote +
          '<div class="raa-image-uploader"' +
            ' data-field-id="' + inputId + '"' +
            ' data-field-key="' + esc(id) + '"' +
            ' data-max="' + maxFiles + '"' +
            ' data-required="' + (req ? 'true' : 'false') + '"' +
            requiredIfAttr +
          '>' +
            '<div class="raa-image-preview-grid"></div>' +
            '<label class="raa-image-add-btn" tabindex="0" role="button" aria-label="' + esc(addBtnLabel) + '">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              ' ' + esc(addBtnLabel) +
              '<input type="file" accept="image/jpeg,image/png,image/jpg,image/webp"' + (maxFiles > 1 ? ' multiple' : '') + ' class="raa-image-file-input" style="position:absolute;opacity:0;width:0.1px;height:0.1px;overflow:hidden;" tabindex="-1">' +
            '</label>' +
            '<p class="raa-image-counter" aria-live="polite">' + counterText + '</p>' +
            '<p class="raa-image-device-note">' + RAA_icon('smartphone', 13) + ' iPhone users: photos must be JPEG or PNG. If uploads fail, go to <strong>Settings ' + RAA_icon('chevron-right', 11) + ' Camera ' + RAA_icon('chevron-right', 11) + ' Formats</strong> and select <strong>Most Compatible</strong>.</p>' +
            '<input type="hidden" name="' + esc(id) + '" class="raa-image-hidden-input" value="[]">' +
            errorEl +
          '</div>' +
        '</div>'
      );
    }

    // ── Standard input types ──────────────────────────────────────────────
    var reqMark = req ? ' <span class="raa-form-required" aria-hidden="true">*</span>' : '';
    var labelHtml =
      '<label class="raa-form-label" for="' + inputId + '">' + esc(label) + reqMark + '</label>';

    var inputHtml = '';

    switch (type) {
      case 'text':
        // If this is the Entry ID CODE field and the customer has purchased entries,
        // render a dropdown of their order codes instead of a free-text input.
        var entryIdCodes = (formConfig && formConfig.entryIdCodes) || [];
        var entryIdLabels = (formConfig && formConfig.entryIdLabels) || [];
        var isEntryIdField = /entry.?id|id.?code/i.test(label) || /entry.?id|id.?code/i.test(id);
        if (isEntryIdField && entryIdCodes.length > 0) {
          // Parse ui text config for entry code section
          var uiText = {};
          try { uiText = JSON.parse(formConfig.uiTextJson || '{}'); } catch(e) {}
          var codePlaceholder = uiText.code_placeholder || '— Select your entry code —';
          var codeHelper = uiText.code_helper || 'These are the entry codes from your recent orders. Select the one for this entry.';
          var codeSubmittedWarning = uiText.code_submitted_warning || 'You have already submitted an entry for this code. Each code can only be used once.';
          var codeManageLink = uiText.code_manage_link || 'Manage My Entries';
          var codeManualToggle = uiText.code_manual_toggle || "My code isn't in this list";
          var codeManualPlaceholder = uiText.code_manual_placeholder || 'e.g. 1234-ENR';
          var codeManualBack = uiText.code_manual_back || 'Back to dropdown';

          var codeOpts = entryIdCodes.map(function (code, ci) {
            var rawLabel = entryIdLabels[ci] || '';
            // Label may be "Product Title | Variant Title" — show only the variant part in the dropdown
            var dispLabel = rawLabel.indexOf(' | ') !== -1 ? rawLabel.split(' | ')[1] : rawLabel;
            var optLabel = dispLabel ? code + ' \u2014 ' + dispLabel : code;
            return '<option value="' + esc(code) + '">' + esc(optLabel) + '</option>';
          }).join('');
          inputHtml =
            '<select id="' + inputId + '" name="' + esc(id) + '" class="raa-form-select" data-entry-id-select="true"' + reqAttr + groupAttr + '>' +
              '<option value="">' + esc(codePlaceholder) + '</option>' +
              codeOpts +
            '</select>' +
            '<div class="raa-form-entry-submitted-warning" style="display:none;margin-top:8px;padding:10px 14px;background:#fef9c3;border:1px solid #fde047;border-radius:6px;font-size:13px;color:#713f12">' +
              RAA_icon('triangle-alert', 13) + ' ' + esc(codeSubmittedWarning) + ' ' +
              '<a href="/pages/manage-my-entries" style="color:#713f12;font-weight:700;text-decoration:underline">' + esc(codeManageLink) + ' ' + RAA_icon('arrow-right', 12) + '</a>' +
            '</div>' +
            '<p class="raa-form-field-note" style="margin-top:6px">' + esc(codeHelper) + '</p>' +
            '<div class="raa-entry-manual-toggle-row" style="margin-top:4px">' +
              '<button type="button" class="raa-entry-manual-toggle" style="background:none;border:none;padding:0;font-size:13px;color:var(--color-link,#0066cc);cursor:pointer;text-decoration:underline">' + esc(codeManualToggle) + '</button>' +
            '</div>' +
            '<div class="raa-entry-manual-wrap" style="display:none;margin-top:8px">' +
              '<input type="text" name="' + esc(id) + '" class="raa-form-input raa-entry-manual-input" placeholder="' + esc(codeManualPlaceholder) + '" disabled autocomplete="off">' +
              '<button type="button" class="raa-entry-manual-back" style="background:none;border:none;padding:0;font-size:12px;color:var(--color-link,#0066cc);cursor:pointer;text-decoration:underline;display:block;margin-top:6px">' + RAA_icon('arrow-left', 12) + ' ' + esc(codeManualBack) + '</button>' +
            '</div>';
        } else {
          inputHtml = '<input type="text" id="' + inputId + '" name="' + esc(id) + '" class="raa-form-input" autocomplete="off"' + reqAttr + groupAttr + placeholder + '>';
        }
        break;

      case 'textarea':
        inputHtml = '<textarea id="' + inputId + '" name="' + esc(id) + '" class="raa-form-textarea" rows="4"' + reqAttr + groupAttr + placeholder + '></textarea>';
        break;

      case 'email':
        inputHtml = '<input type="email" id="' + inputId + '" name="' + esc(id) + '" class="raa-form-input" autocomplete="off"' + reqAttr + groupAttr + placeholder + '>';
        break;

      case 'phone':
        inputHtml = '<input type="tel" id="' + inputId + '" name="' + esc(id) + '" class="raa-form-input" autocomplete="off"' + reqAttr + groupAttr + placeholder + '>';
        break;

      case 'number':
        var minA = field.min !== undefined ? ' min="' + field.min + '"' : '';
        var maxA = field.max !== undefined ? ' max="' + field.max + '"' : '';
        inputHtml = '<input type="number" id="' + inputId + '" name="' + esc(id) + '" class="raa-form-input" autocomplete="off"' + reqAttr + groupAttr + placeholder + minA + maxA + '>';
        break;

      case 'url':
        inputHtml = '<input type="url" id="' + inputId + '" name="' + esc(id) + '" class="raa-form-input" autocomplete="off"' + reqAttr + groupAttr + placeholder + '>';
        break;

      case 'date':
        inputHtml = '<input type="date" id="' + inputId + '" name="' + esc(id) + '" class="raa-form-input"' + reqAttr + '>';
        break;

      case 'time':
        inputHtml = '<input type="time" id="' + inputId + '" name="' + esc(id) + '" class="raa-form-input"' + reqAttr + '>';
        break;

      case 'select':
        var opts = (field.options || []).map(function (opt) {
          var v = typeof opt === 'object' ? opt.value : opt;
          var l = typeof opt === 'object' ? opt.label : opt;
          return '<option value="' + esc(v) + '">' + esc(l) + '</option>';
        }).join('');
        inputHtml =
          '<select id="' + inputId + '" name="' + esc(id) + '" class="raa-form-select"' + reqAttr + groupAttr + '>' +
            '<option value="">— Please select —</option>' +
            opts +
          '</select>';
        if (field.warnIfRecent) {
          inputHtml +=
            '<div class="raa-form-year-warning" data-year-warning="' + inputId + '" style="display:none" role="alert">' +
              '<strong>&#9888;&#65039; Please note:</strong> We do require a minimum of 12 months of ' +
              'online presence, preferably with sales history, for your application to be considered ' +
              'for approval. You are welcome to continue your application, but please be aware of this requirement.' +
            '</div>';
        }
        break;

      case 'radio':
        var radioOpts = (field.options || []).map(function (opt, ri) {
          var v = typeof opt === 'object' ? opt.value : opt;
          var l = typeof opt === 'object' ? opt.label : opt;
          var r2 = (req && ri === 0) ? ' required data-orig-required="true"' : '';
          return (
            '<label class="raa-form-radio-label">' +
              '<input type="radio" name="' + esc(id) + '" value="' + esc(v) + '"' + r2 + '>' +
              ' ' + esc(l) +
            '</label>'
          );
        }).join('');
        inputHtml = '<div class="raa-form-radio-group" role="group">' + radioOpts + '</div>';
        break;

      case 'checkbox':
      case 'multiple_choice':
        var cbOpts = (field.options || []).map(function (opt) {
          var v = typeof opt === 'object' ? opt.value : opt;
          var l = typeof opt === 'object' ? opt.label : opt;
          return (
            '<label class="raa-form-checkbox-label">' +
              '<input type="checkbox" name="' + esc(id) + '[]" value="' + esc(v) + '">' +
              ' ' + esc(l) +
            '</label>'
          );
        }).join('');
        inputHtml = '<div class="raa-form-checkbox-group" role="group">' + cbOpts + '</div>';
        break;

      case 'rating':
        var rMax = field.max || 5;
        var stars = '';
        for (var s = 1; s <= rMax; s++) {
          stars +=
            '<label class="raa-form-rating-label" title="' + s + ' star' + (s !== 1 ? 's' : '') + '">' +
              '<input type="radio" name="' + esc(id) + '" value="' + s + '"' + (req && s === 1 ? ' required data-orig-required="true"' : '') + '>' +
              '<span class="raa-form-rating-star" data-value="' + s + '">' + RAA_icon('star', 24, null, 'fill:currentColor;') + '</span>' +
            '</label>';
        }
        inputHtml = '<div class="raa-form-rating" data-rating-group="' + esc(id) + '">' + stars + '</div>';
        break;

      case 'file':
        inputHtml = '<input type="file" id="' + inputId + '" name="' + esc(id) + '" class="raa-form-file"' + reqAttr + '>';
        break;

      default:
        inputHtml = '<input type="text" id="' + inputId + '" name="' + esc(id) + '" class="raa-form-input" autocomplete="off"' + reqAttr + placeholder + '>';
    }

    return (
      '<div class="raa-form-field' + halfClass + conditionalClass + '" data-field-id="' + inputId + '" data-key="' + esc(id) + '"' + conditionalAttr + '>' +
        labelHtml +
        fieldNote +
        inputHtml +
        errorEl +
      '</div>'
    );
  }

  // ─── IMAGE UPLOADER ──────────────────────────────────────────────────────

  var LARGE_FILE_THRESHOLD = 10 * 1024 * 1024; // 10 MB — preserve originals below this
  var MAX_UPLOAD_PX = 4000; // resize only files above threshold (keeps high quality)
  var THUMB_PX = 400;       // small preview thumbnail

  function makeThumbnail(img) {
    var w = img.width, h = img.height;
    if (w > THUMB_PX || h > THUMB_PX) {
      if (w >= h) { h = Math.round(h * THUMB_PX / w); w = THUMB_PX; }
      else        { w = Math.round(w * THUMB_PX / h); h = THUMB_PX; }
    }
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    c.getContext('2d').drawImage(img, 0, 0, w, h);
    return c.toDataURL('image/jpeg', 0.80);
  }

  function prepareImageFile(file, callback, onError) {
    // Use createObjectURL instead of readAsDataURL — avoids base64-encoding the entire
    // file into memory, which silently fails on Android Chrome / Samsung Internet / older iOS
    // when the photo is large (img.onload never fires, no error thrown, photo disappears).
    var objectUrl = URL.createObjectURL(file);
    var img = new Image();
    img.onerror = function () {
      URL.revokeObjectURL(objectUrl);
      if (onError) onError('"' + file.name + '" could not be decoded. Try saving it as JPEG or PNG first (iPhone users: Settings > Camera > Formats > Most Compatible).');
    };
    img.onload = function () {
      var thumbUrl = makeThumbnail(img);
      if (file.size <= LARGE_FILE_THRESHOLD) {
        // Under 10 MB — upload the original File object directly (no re-encoding needed)
        URL.revokeObjectURL(objectUrl);
        callback({ name: file.name, dataUrl: null, mimeType: file.type || 'image/jpeg', thumbUrl: thumbUrl, originalFile: file });
      } else {
        // Very large file — resize to 4000 px at high quality before uploading
        var w = img.width, h = img.height;
        if (w > MAX_UPLOAD_PX || h > MAX_UPLOAD_PX) {
          if (w >= h) { h = Math.round(h * MAX_UPLOAD_PX / w); w = MAX_UPLOAD_PX; }
          else        { w = Math.round(w * MAX_UPLOAD_PX / h); h = MAX_UPLOAD_PX; }
        }
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        var dataUrl = canvas.toDataURL('image/jpeg', 0.95);
        URL.revokeObjectURL(objectUrl);
        callback({ name: file.name.replace(/\.[^.]+$/, '') + '.jpg', dataUrl: dataUrl, mimeType: 'image/jpeg', thumbUrl: thumbUrl });
      }
    };
    img.src = objectUrl;
  }

  function initImageUploaders(formEl) {
    if (!uploaderFiles) return;
    formEl.querySelectorAll('.raa-image-uploader').forEach(function (uploader) {
      uploaderFiles.set(uploader, []);
      var fileInput   = uploader.querySelector('.raa-image-file-input');
      var previewGrid = uploader.querySelector('.raa-image-preview-grid');
      var counter     = uploader.querySelector('.raa-image-counter');
      var hiddenInput = uploader.querySelector('.raa-image-hidden-input');
      var max = parseInt(uploader.dataset.max) || 1;
      var decodeFailCount = 0;

      function refresh() {
        var files = uploaderFiles.get(uploader) || [];
        var addBtn = uploader.querySelector('.raa-image-add-btn');
        counter.textContent = files.length + ' / ' + max + ' photo' + (max !== 1 ? 's' : '') + ' added';
        if (addBtn) addBtn.style.display = files.length >= max ? 'none' : '';
        hiddenInput.value = JSON.stringify(files.map(function (f) {
          return { name: f.name, mimeType: f.mimeType };
        }));
      }

      function addFiles(newFiles) {
        decodeFailCount = 0;
        var uploaderErrorEl = uploader.querySelector('.raa-form-field-error');
        if (uploaderErrorEl) uploaderErrorEl.textContent = '';
        Array.from(newFiles).forEach(function (file) {
          var files = uploaderFiles.get(uploader) || [];
          if (files.length >= max) return;
          var fileExt = (file.name || '').split('.').pop().toLowerCase();
          var looksLikeImage = file.type.startsWith('image/') || (!file.type && /^(jpg|jpeg|png|gif|webp|heic|heif|bmp|tiff?)$/.test(fileExt));
          if (!looksLikeImage) return;
          prepareImageFile(file, function (fileData) {
            var currentFiles = uploaderFiles.get(uploader) || [];
            if (currentFiles.length >= max) return;
            var idx = currentFiles.length;
            currentFiles.push(fileData);
            uploaderFiles.set(uploader, currentFiles);

            var thumb = document.createElement('div');
            thumb.className = 'raa-image-thumb';
            thumb.dataset.idx = idx;
            thumb.innerHTML =
              '<img src="' + fileData.thumbUrl + '" alt="' + esc(fileData.name) + '">' +
              '<button type="button" class="raa-image-remove" aria-label="Remove photo">&#10005;</button>';

            thumb.querySelector('.raa-image-remove').addEventListener('click', function () {
              var cf = uploaderFiles.get(uploader) || [];
              var i = parseInt(thumb.dataset.idx);
              cf.splice(i, 1);
              uploaderFiles.set(uploader, cf);
              thumb.remove();
              previewGrid.querySelectorAll('.raa-image-thumb').forEach(function (t, ti) {
                t.dataset.idx = ti;
              });
              refresh();
            });

            previewGrid.appendChild(thumb);
            refresh();
          }, function () {
            decodeFailCount++;
            if (uploaderErrorEl) {
              uploaderErrorEl.textContent = decodeFailCount + ' photo' + (decodeFailCount > 1 ? 's' : '') + ' could not be decoded and were skipped. Photos must be JPEG or PNG — iPhone users: Settings > Camera > Formats > Most Compatible.';
            }
          });
        });
      }

      fileInput.addEventListener('change', function () {
        addFiles(this.files);
        this.value = '';
      });

      // Keyboard access for add button
      var addBtn = uploader.querySelector('.raa-image-add-btn');
      if (addBtn) {
        addBtn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            fileInput.click();
          }
        });
      }

      refresh();
    });
  }

  // ─── YEAR WARNING ─────────────────────────────────────────────────────────

  function initYearWarnings(formEl) {
    formEl.querySelectorAll('.raa-form-year-warning').forEach(function (warning) {
      var selectId = warning.dataset.yearWarning;
      var select = formEl.querySelector('#' + selectId);
      if (!select) return;
      var currentYear = new Date().getFullYear();
      select.addEventListener('change', function () {
        var selected = parseInt(this.value);
        if (!selected) { warning.style.display = 'none'; return; }
        // Show warning if started within the last ~12 months (this year or last year)
        warning.style.display = (currentYear - selected) <= 1 ? 'block' : 'none';
      });
    });
  }

  // ─── ENTRY CODE AUTO-POPULATE ────────────────────────────────────────────

  function initEntryCodeAutoPopulate(formEl, config) {
    var entryIdSelect = formEl.querySelector('[data-entry-id-select="true"]');
    if (!entryIdSelect) return;

    var entryIdCodes  = (config && config.entryIdCodes)  || [];
    var entryIdLabels = (config && config.entryIdLabels) || [];
    var storageKey    = 'raa_submitted_' + (config.handle || 'form');
    var fieldWrapper  = entryIdSelect.closest('.raa-form-field');
    var warning       = fieldWrapper ? fieldWrapper.querySelector('.raa-form-entry-submitted-warning') : null;

    function getSubmitted() {
      try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (e) { return []; }
    }

    function updateWarning(code) {
      if (!warning) return;
      var sub = getSubmitted();
      warning.style.display = (code && sub.indexOf(code) !== -1) ? 'block' : 'none';
    }

    // Manual entry toggle
    var toggleRow   = fieldWrapper ? fieldWrapper.querySelector('.raa-entry-manual-toggle-row') : null;
    var toggleBtn   = fieldWrapper ? fieldWrapper.querySelector('.raa-entry-manual-toggle')     : null;
    var manualWrap  = fieldWrapper ? fieldWrapper.querySelector('.raa-entry-manual-wrap')        : null;
    var manualInput = fieldWrapper ? fieldWrapper.querySelector('.raa-entry-manual-input')       : null;
    var backBtn     = fieldWrapper ? fieldWrapper.querySelector('.raa-entry-manual-back')        : null;
    var wasRequired = entryIdSelect.hasAttribute('data-orig-required');

    if (toggleBtn && manualWrap && manualInput) {
      toggleBtn.addEventListener('click', function () {
        entryIdSelect.disabled = true;
        entryIdSelect.removeAttribute('required');
        if (toggleRow) toggleRow.style.display = 'none';
        manualWrap.style.display = 'block';
        manualInput.disabled = false;
        if (wasRequired) {
          manualInput.setAttribute('required', '');
          manualInput.setAttribute('data-orig-required', 'true');
        }
        if (warning) warning.style.display = 'none';
        manualInput.focus();
      });

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          manualInput.disabled = true;
          manualInput.removeAttribute('required');
          manualInput.removeAttribute('data-orig-required');
          manualInput.value = '';
          entryIdSelect.disabled = false;
          if (wasRequired) entryIdSelect.setAttribute('required', '');
          manualWrap.style.display = 'none';
          if (toggleRow) toggleRow.style.display = '';
          updateWarning(entryIdSelect.value);
        });
      }
    }

    entryIdSelect.addEventListener('change', function () {
      var selectedCode  = this.value;
      var selectedIndex = entryIdCodes.indexOf(selectedCode);
      var variantTitle  = selectedIndex >= 0 ? (entryIdLabels[selectedIndex] || '') : '';

      updateWarning(selectedCode);
      if (!variantTitle) return;

      // Label format can be:
      //   "Product Title | Variant Title"  (multi-variant: category | level)
      //   "Product Title"                  (single variant: title only)
      var pipeIdx = variantTitle.indexOf(' | ');
      var levelPart = '';
      var categoryPart = '';
      if (pipeIdx !== -1) {
        // New format: product title before pipe = category, variant title after pipe = level
        var productTitlePart = variantTitle.slice(0, pipeIdx).trim();
        var variantPart      = variantTitle.slice(pipeIdx + 3).trim();
        categoryPart = productTitlePart.replace(/\s+entry\s*$/i, '').trim();
        // Level is the variant title — try parens first, then use whole string
        var lvlMatch = variantPart.match(/\(([^)]+)\)\s*$/);
        levelPart = lvlMatch ? lvlMatch[1].trim() : variantPart;
      } else {
        // Old / single-variant format: "Category Entry (Level)" or just product title
        var lvlMatch = variantTitle.match(/\(([^)]+)\)\s*$/);
        // Normalise "Open Entry" / "Virtuoso Entry" → "Open Level" / "Virtuoso Level"
        // so products mistakenly named with "Entry" instead of "Level" still match
        levelPart    = lvlMatch ? lvlMatch[1].trim().replace(/^(\w+)\s+Entry$/i, '$1 Level') : '';
        categoryPart = lvlMatch
          ? variantTitle.slice(0, lvlMatch.index).replace(/\s+entry\s*$/i, '').trim()
          : variantTitle.replace(/\s+entry\s*$/i, '').trim();
      }

      // Find both selects first, then set category before level
      // (level is applied last so any side-effects from category's change event can't undo it)
      var levelSel = null, catSel = null;
      formEl.querySelectorAll('select').forEach(function (s) {
        if (s === entryIdSelect) return;
        if (/competition.?level|level/i.test(s.name || s.id)) levelSel = s;
        else if (/category/i.test(s.name || s.id)) catSel = s;
      });

      // Auto-populate Category first, Level last.
      // Wrapped in try-catch: if category's dispatchEvent causes a theme JS error it
      // won't abort execution and prevent level from being set.
      try { if (categoryPart && catSel) matchOption(catSel, categoryPart); } catch(e) {}
      try { if (levelPart && levelSel) matchOption(levelSel, levelPart); } catch(e) {}
      // setTimeout 0 re-applies level after any synchronous theme resets finish
      if (levelPart && levelSel) {
        setTimeout(function () { matchOption(levelSel, levelPart); }, 0);
      }
    });

    // Run on init (handles back-navigation / browser autofill)
    updateWarning(entryIdSelect.value);

    // Live API check: supplement localStorage with server-side submission data
    if (config.customerEmail && config.googleSheetTab && config.proxyUrl) {
      var apiUrl = config.proxyUrl + '/api/submit-form?action=get-entries' +
        '&email=' + encodeURIComponent(config.customerEmail) +
        '&tab='   + encodeURIComponent(config.googleSheetTab) +
        '&form='  + encodeURIComponent(config.handle || 'competition-entry');
      fetch(apiUrl)
        .then(function (r) { return r.ok ? r.json() : { entries: [] }; })
        .then(function (data) {
          var entries     = data.entries || [];
          var apiCodes    = [];
          entries.forEach(function (row) {
            var vals = Object.values(row);
            entryIdCodes.forEach(function (code) {
              if (vals.indexOf(code) !== -1 && apiCodes.indexOf(code) === -1) apiCodes.push(code);
            });
          });
          if (apiCodes.length === 0) return;
          // Merge into localStorage and re-check current selection
          try {
            var stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
            var merged = stored.slice();
            apiCodes.forEach(function (c) { if (merged.indexOf(c) === -1) merged.push(c); });
            localStorage.setItem(storageKey, JSON.stringify(merged));
          } catch (e) {}
          updateWarning(entryIdSelect.value);
        })
        .catch(function () {});
    }
  }

  function matchOption(select, text) {
    if (!text || !select) return false;
    var lText = text.toLowerCase();
    var opts = select.options;
    var i;

    // 1. Exact match (value or display label)
    for (i = 0; i < opts.length; i++) {
      if (opts[i].value.toLowerCase() === lText || opts[i].text.toLowerCase() === lText) {
        select.value = opts[i].value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    // 2. Starts-with
    for (i = 0; i < opts.length; i++) {
      if (opts[i].value.toLowerCase().indexOf(lText) === 0 || opts[i].text.toLowerCase().indexOf(lText) === 0) {
        select.value = opts[i].value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    // 3. Contains
    for (i = 0; i < opts.length; i++) {
      if (opts[i].value.toLowerCase().indexOf(lText) !== -1 || opts[i].text.toLowerCase().indexOf(lText) !== -1) {
        select.value = opts[i].value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    // 4. Reverse starts-with: search text starts with option text (pick longest match)
    //    Handles e.g. "Prem/Newborn Reborn" matching option "Prem/Newborn"
    var best = -1, bestLen = -1, lOpt;
    for (i = 0; i < opts.length; i++) {
      lOpt = opts[i].text.toLowerCase();
      if (lOpt.length > 0 && lText.indexOf(lOpt) === 0 && lOpt.length > bestLen) {
        best = i; bestLen = lOpt.length;
      }
    }
    if (best !== -1) {
      select.value = opts[best].value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    // 5. Reverse contains: search text contains option text (pick longest match)
    best = -1; bestLen = -1;
    for (i = 0; i < opts.length; i++) {
      lOpt = opts[i].text.toLowerCase();
      if (lOpt.length > 0 && lText.indexOf(lOpt) !== -1 && lOpt.length > bestLen) {
        best = i; bestLen = lOpt.length;
      }
    }
    if (best !== -1) {
      select.value = opts[best].value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    // 6. Normalized comparison — treat " or ", "/" and "," as equivalent separators
    //    Handles e.g. "Fantasy/Alternate or Novelty" matching "Fantasy/Alternate/Novelty"
    function normSep(s) { return s.replace(/\s+or\s+/gi, '/').replace(/\s*[/,]\s*/g, '/'); }
    var nText = normSep(lText);
    best = -1; bestLen = -1;
    for (i = 0; i < opts.length; i++) {
      var nOpt = normSep(opts[i].text.toLowerCase());
      if (nOpt === nText || nOpt.indexOf(nText) === 0 || nText.indexOf(nOpt) === 0 || nOpt.indexOf(nText) !== -1 || nText.indexOf(nOpt) !== -1) {
        if (nOpt.length > bestLen) { best = i; bestLen = nOpt.length; }
      }
    }
    if (best !== -1) {
      select.value = opts[best].value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  // ─── CONDITIONAL FIELDS ──────────────────────────────────────────────────

  function initConditionals(formEl) {
    var conditionals = formEl.querySelectorAll('[data-show-if]');
    if (!conditionals.length) return;

    function evalConditionals() {
      conditionals.forEach(function (el) {
        var condition;
        try { condition = JSON.parse(el.getAttribute('data-show-if')); } catch (e) { return; }

        var triggerEl = formEl.querySelector('[name="' + condition.field + '"]');
        if (!triggerEl) return;

        var shouldShow = (condition.values || []).indexOf(triggerEl.value) !== -1;
        el.style.display = shouldShow ? '' : 'none';

        el.querySelectorAll('input, textarea, select').forEach(function (input) {
          if (input.getAttribute('data-orig-required') === 'true') {
            if (shouldShow) input.setAttribute('required', '');
            else input.removeAttribute('required');
          }
        });
      });
    }

    formEl.addEventListener('change', evalConditionals);
    evalConditionals();
  }

  // ─── RATING STAR INTERACTION ─────────────────────────────────────────────

  function initRatingInputs(container) {
    container.querySelectorAll('.raa-form-rating').forEach(function (group) {
      group.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          var selected = parseInt(this.value);
          group.querySelectorAll('.raa-form-rating-star').forEach(function (star) {
            star.classList.toggle('raa-form-rating-star--active', parseInt(star.dataset.value) <= selected);
          });
        });
      });
    });
  }

  // ─── URL BLUR VALIDATION ─────────────────────────────────────────────────

  function initUrlValidation(formEl) {
    formEl.querySelectorAll('input[type="url"]').forEach(function (input) {
      input.addEventListener('blur', function () {
        var fieldEl = input.closest('.raa-form-field');
        var errorEl = fieldEl && fieldEl.querySelector('.raa-form-field-error');
        var val = input.value.trim();
        if (!val) {
          if (fieldEl) fieldEl.classList.remove('raa-form-field--invalid');
          if (errorEl) errorEl.textContent = '';
          return;
        }
        if (/\s/.test(val)) {
          if (fieldEl) fieldEl.classList.add('raa-form-field--invalid');
          if (errorEl) errorEl.textContent = 'Links cannot contain spaces — please paste the full URL from your browser\'s address bar (e.g. https://www.instagram.com/yourhandle)';
          return;
        }
        if (!/^https?:\/\//i.test(val)) val = 'https://' + val;
        input.value = val;
        if (!isValidUrl(val)) {
          if (fieldEl) fieldEl.classList.add('raa-form-field--invalid');
          if (errorEl) errorEl.textContent = 'This doesn\'t look like a valid link. Please paste the full URL from your browser\'s address bar (e.g. https://www.facebook.com/yourpage)';
        } else {
          if (fieldEl) fieldEl.classList.remove('raa-form-field--invalid');
          if (errorEl) errorEl.textContent = '';
        }
      });
    });
  }

  // ─── VALIDATION ──────────────────────────────────────────────────────────

  function validateForm(formEl) {
    var valid = true;

    // Clear all errors
    formEl.querySelectorAll('.raa-form-field-error').forEach(function (el) { el.textContent = ''; });
    formEl.querySelectorAll('.raa-form-field--invalid').forEach(function (el) {
      el.classList.remove('raa-form-field--invalid');
    });

    // Standard required fields (skip if inside hidden conditional)
    formEl.querySelectorAll('[required]').forEach(function (input) {
      var wrapper = input.closest('[data-show-if]');
      if (wrapper && wrapper.style.display === 'none') return;

      var empty = input.type === 'checkbox' ? !input.checked
                : input.type === 'file'     ? (!input.files || !input.files.length)
                : !input.value.trim();

      if (empty) {
        markError(input, 'This field is required.');
        if (valid) input.focus();
        valid = false;
      }
    });

    // Image uploaders — check required ones (supports requiredIf conditional)
    if (uploaderFiles) {
      formEl.querySelectorAll('.raa-image-uploader').forEach(function (uploader) {
        var wrapper = uploader.closest('[data-show-if]');
        if (wrapper && wrapper.style.display === 'none') return;

        var isRequired = uploader.dataset.required === 'true';
        if (!isRequired && uploader.dataset.requiredIf) {
          try {
            var rCond = JSON.parse(uploader.dataset.requiredIf);
            var rTrigger = formEl.querySelector('[name="' + rCond.field + '"]');
            if (rTrigger && (rCond.values || []).indexOf(rTrigger.value) !== -1) {
              isRequired = true;
            }
          } catch (e) {}
        }
        if (!isRequired) return;
        var files = uploaderFiles.get(uploader) || [];
        if (files.length === 0) {
          var fieldEl = uploader.closest('.raa-form-field');
          var errorEl = uploader.querySelector('.raa-form-field-error');
          if (fieldEl) fieldEl.classList.add('raa-form-field--invalid');
          if (errorEl) errorEl.textContent = 'Please upload at least one photo.';
          if (valid) {
            var addBtn = uploader.querySelector('.raa-image-add-btn');
            if (addBtn) addBtn.focus();
          }
          valid = false;
        }
      });
    }

    // Required groups — a configurable minimum number of fields in the group must be filled
    var groups = {};
    formEl.querySelectorAll('[data-required-group]').forEach(function (input) {
      var wrapper = input.closest('[data-show-if]');
      if (wrapper && wrapper.style.display === 'none') return;
      var g = input.getAttribute('data-required-group');
      var min = parseInt(input.getAttribute('data-required-group-min') || '1') || 1;
      if (!groups[g]) groups[g] = { count: 0, min: 1, inputs: [] };
      if (min > groups[g].min) groups[g].min = min;
      groups[g].inputs.push(input);
      if (input.value && input.value.trim()) groups[g].count++;
    });
    Object.keys(groups).forEach(function (g) {
      var grp = groups[g];
      if (grp.count < grp.min && grp.inputs.length) {
        var first = grp.inputs[0];
        var need = grp.min - grp.count;
        var msg = grp.min === 1
          ? 'Please provide at least one link so we can verify your online presence.'
          : grp.count === 0
            ? 'Please provide at least ' + grp.min + ' links so we can verify your online presence.'
            : 'Please provide ' + need + ' more link' + (need > 1 ? 's' : '') + ' — we need at least ' + grp.min + ' to verify your online presence.';
        markError(first, msg);
        if (valid) first.focus();
        valid = false;
      }
    });

    // Email format
    formEl.querySelectorAll('input[type="email"]').forEach(function (input) {
      var wrapper = input.closest('[data-show-if]');
      if (wrapper && wrapper.style.display === 'none') return;
      if (input.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
        markError(input, 'Please enter a valid email address.');
        if (valid) input.focus();
        valid = false;
      }
    });

    // Auto-prepend https:// then validate URL fields
    formEl.querySelectorAll('input[type="url"]').forEach(function (input) {
      var wrapper = input.closest('[data-show-if]');
      if (wrapper && wrapper.style.display === 'none') return;
      if (!input.value.trim()) return;
      if (/\s/.test(input.value)) {
        markError(input, 'Links cannot contain spaces — please paste the full URL from your browser\'s address bar (e.g. https://www.instagram.com/yourhandle)');
        if (valid) input.focus();
        valid = false;
        return;
      }
      if (!/^https?:\/\//i.test(input.value)) {
        input.value = 'https://' + input.value;
      }
      if (!isValidUrl(input.value)) {
        markError(input, 'This doesn\'t look like a valid link. Please paste the full URL from your browser\'s address bar (e.g. https://www.facebook.com/yourpage)');
        if (valid) input.focus();
        valid = false;
      }
    });

    return valid;
  }

  function isValidUrl(val) {
    if (/\s/.test(val)) return false;
    // Must have a proper domain with a TLD — rejects handles like https://tippytoescreations or https://@name
    return /^https?:\/\/[^@\s/]+\.[^@\s.]{2,}/i.test(val) && !/@/.test(val);
  }

  function markError(input, message) {
    var fieldEl = input.closest('.raa-form-field');
    if (fieldEl) {
      fieldEl.classList.add('raa-form-field--invalid');
      var errorEl = fieldEl.querySelector('.raa-form-field-error');
      if (errorEl) errorEl.textContent = message;
    }
  }

  // ─── SUBMISSION ──────────────────────────────────────────────────────────

  function handleSubmit(e, formEl, config, container) {
    e.preventDefault();
    if (!validateForm(formEl)) return;

    var submitBtn  = formEl.querySelector('.raa-form-submit-btn');
    var errorBanner = container.querySelector('.raa-form-error-banner');
    var successEl  = container.querySelector('.raa-form-success');

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting\u2026';
    errorBanner.style.display = 'none';

    // Collect form data
    var data = {};
    var formData = new FormData(formEl);
    formData.forEach(function (value, key) {
      if (key === '__proto__') return;
      if (key.endsWith('[]')) {
        var cleanKey = key.slice(0, -2);
        if (!data[cleanKey]) data[cleanKey] = [];
        data[cleanKey].push(value);
      } else {
        data[key] = value;
      }
    });

    // Remove data for hidden conditional fields
    formEl.querySelectorAll('[data-show-if]').forEach(function (el) {
      if (el.style.display === 'none') {
        var key = el.getAttribute('data-key');
        if (key) delete data[key];
        el.querySelectorAll('[name]').forEach(function (input) {
          var n = input.name.replace(/\[\]$/, '');
          delete data[n];
        });
      }
    });

    // Strip empty photo field placeholders ("[]" = no files staged in hidden input)
    Object.keys(data).forEach(function (key) {
      if (data[key] === '[]') delete data[key];
    });

    // Collect image uploaders with files
    var uploaders = [];
    if (uploaderFiles) {
      formEl.querySelectorAll('.raa-image-uploader').forEach(function (uploader) {
        var wrapper = uploader.closest('[data-show-if]');
        if (wrapper && wrapper.style.display === 'none') return;
        var files = uploaderFiles.get(uploader) || [];
        if (files.length > 0) {
          uploaders.push({ key: uploader.dataset.fieldKey, files: files });
        }
      });
    }

    function doSubmit() {
      fetch(config.proxyUrl + '/api/submit-form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          form_handle: config.handle,
          google_sheet_tab: config.googleSheetTab,
          customer_email: config.customerEmail,
          data: data
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Server error ' + res.status);
          // Save submitted entry code to localStorage so it shows as already-done next time
          var entrySelect = formEl.querySelector('[data-entry-id-select="true"]');
          if (entrySelect && entrySelect.value) {
            try {
              var lsKey = 'raa_submitted_' + config.handle;
              var submitted = JSON.parse(localStorage.getItem(lsKey) || '[]');
              if (submitted.indexOf(entrySelect.value) === -1) submitted.push(entrySelect.value);
              localStorage.setItem(lsKey, JSON.stringify(submitted));
            } catch (e) {}
          }
          formEl.style.display = 'none';
          successEl.style.display = 'block';
          successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        })
        .catch(function (err) {
          console.error('[RAA Form]', err);
          errorBanner.textContent = 'Something went wrong. Please check your answers and try again.';
          errorBanner.style.display = 'block';
          errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
          submitBtn.disabled = false;
          submitBtn.textContent = config.submitLabel || 'Submit';
        });
    }

    if (uploaders.length === 0) {
      doSubmit();
      return;
    }

    // Guard: very old browsers without fetch support
    if (typeof fetch === 'undefined') {
      errorBanner.textContent = 'Your browser does not support photo uploads. Please update to a recent version of Safari, Chrome, or Firefox and try again.';
      errorBanner.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = config.submitLabel || 'Submit';
      return;
    }

    // Upload photos first (individually to preserve quality + avoid body-size limits), then submit
    submitBtn.textContent = 'Uploading photos\u2026';

    var uploadPayload = [];
    uploaders.forEach(function (u) {
      u.files.forEach(function (f) {
        uploadPayload.push({ key: u.key, name: f.name, dataUrl: f.dataUrl, mimeType: f.mimeType, originalFile: f.originalFile || null });
      });
    });

    // Get Cloudinary signature from proxy (no file data sent to Vercel)
    Promise.all([
      fetch(config.proxyUrl + '/api/upload-files?form_handle=' + encodeURIComponent(config.handle))
        .then(function (res) { return res.json(); })
    ]).then(function (sigResults) {
      var sig = sigResults[0];
      if (!sig.signature) throw new Error('Could not get upload authorisation. Please refresh the page and try again.');

      var uploadedCount = 0;
      var totalCount = uploadPayload.length;

      // Polyfill for Promise.allSettled — avoids the `this`-binding error on older Safari
      // where calling a stored reference to Promise.allSettled loses the Promise receiver.
      function allSettled(promises) {
        return Promise.all(promises.map(function (p) {
          return Promise.resolve(p).then(
            function (v) { return { status: 'fulfilled', value: v }; },
            function (e) { return { status: 'rejected', reason: e }; }
          );
        }));
      }

      // Upload a single file to Cloudinary, retrying up to maxAttempts times on failure.
      function uploadFile(file, maxAttempts) {
        function attempt(attemptsLeft) {
          var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
          var timeout = ctrl ? setTimeout(function () { ctrl.abort(); }, 120000) : null;

          var form = new FormData();
          if (file.originalFile) {
            form.append('file', file.originalFile, file.name);
          } else {
            form.append('file', file.dataUrl);
          }
          form.append('api_key', sig.apiKey);
          form.append('timestamp', String(sig.timestamp));
          form.append('signature', sig.signature);
          form.append('folder', sig.folder);

          return fetch('https://api.cloudinary.com/v1_1/' + sig.cloudName + '/image/upload', {
            method: 'POST',
            body: form,
            signal: ctrl ? ctrl.signal : undefined
          })
            .then(function (res) {
              if (timeout) clearTimeout(timeout);
              return res.json().then(function (body) {
                if (!res.ok) throw new Error((body.error && body.error.message) || ('Upload error ' + res.status));
                return body;
              });
            })
            .then(function (result) {
              uploadedCount++;
              submitBtn.textContent = 'Uploading photos\u2026 (' + uploadedCount + '/' + totalCount + ')';
              return { key: file.key, name: file.name, url: result.secure_url };
            })
            .catch(function (err) {
              if (timeout) clearTimeout(timeout);
              // Retry on any error except deliberate abort after max retries
              if (attemptsLeft > 1) {
                return new Promise(function (resolve) { setTimeout(resolve, 3000); })
                  .then(function () { return attempt(attemptsLeft - 1); });
              }
              // All retries exhausted
              if (err.name === 'AbortError') {
                throw new Error('"' + file.name + '" timed out. Please check your internet connection and try again.');
              }
              throw err;
            });
        }
        return attempt(maxAttempts || 3);
      }

      return allSettled(uploadPayload.map(function (file) {
        return uploadFile(file, 3);
      }));
    })
      .then(function (results) {
        // Separate successes from failures
        var succeeded = [], failedNames = [];
        results.forEach(function (r) {
          if (r.status === 'fulfilled' && r.value) succeeded.push(r.value);
          else if (r.status === 'rejected') failedNames.push(r.reason && r.reason.message ? r.reason.message : 'A photo failed to upload.');
        });

        if (succeeded.length === 0) {
          throw new Error('All photos failed to upload. Please try again or contact us directly.');
        }

        if (failedNames.length > 0) {
          // Partial failure — warn but continue with what succeeded
          errorBanner.textContent = failedNames.length + ' photo(s) could not be uploaded and were skipped: ' + failedNames.join(' | ');
          errorBanner.style.display = 'block';
        }

        // Group returned URLs by field key
        var grouped = {};
        succeeded.forEach(function (f) {
          if (!grouped[f.key]) grouped[f.key] = [];
          grouped[f.key].push(f.url);
        });
        Object.keys(grouped).forEach(function (key) {
          data[key] = grouped[key].join('\n');
        });
        submitBtn.textContent = 'Submitting\u2026';
        doSubmit();
      })
      .catch(function (err) {
        console.error('[RAA Form] Upload error:', err);
        errorBanner.textContent = 'Photo upload failed — please check your internet connection and try again. If the problem continues, email us your photos directly. (' + (err.message || 'Unknown error') + ')';
        errorBanner.style.display = 'block';
        errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
        submitBtn.disabled = false;
        submitBtn.textContent = config.submitLabel || 'Submit';
      });
  }

  // ─── HELPERS ─────────────────────────────────────────────────────────────

  function esc(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // ─── BOOT ────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
  } else {
    initForms();
  }
})();

